import React, { useEffect, useRef, useState } from "react";
import { handleKeyPress } from "components/shared/helpers/keyPressHelpers";
import useClickOutsideElement from "components/shared/hooks/useClickOutsideElement";

const popoverText = "AI responses may be inaccurate or inappropriate.";

const popoverOptions = {
  container: "body",
  content: popoverText,
  html: true,
  placement: "bottom",
  template: `
    <div class="ai-disclaimer-popover popover tw-w-[198px] tw-bg-teal tw-border-0" role="tooltip">
      <div class="arrow !tw-border-b-teal after:!tw-border-b-teal"></div>
      <div class="popover-body button-2 tw-text-white tw-py-1 tw-px-2">
        ${popoverText}
      </div>
    </div>
  `,
  toggle: "popover",
  trigger: "manual"
};

export default function DisclaimerText({ className = "" }) {
  const [tooltipActive, setTooltipActive] = useState(false);
  const tooltipRef = useRef();
  const touchEventRef = useRef(false);

  // For whatever reason, iOS is triggering both mouseenter and click events
  // when tapping. This is used at the start of the event to determine if we
  // need to skip the mouseenter event
  const setTouchActive = () => {
    touchEventRef.current = true;
  };

  const dismissPopover = () => {
    $(tooltipRef.current).popover("hide");
  };

  const showPopover = () => {
    $(tooltipRef.current).popover("show");
  };
  const handleKeyDown = (event) => {
    handleKeyPress(event, () => setTooltipActive(!tooltipActive));
  };

  // Setup the popover
  useEffect(() => {
    $(tooltipRef.current).popover(popoverOptions);
  }, []);

  // Use state to control tooltip appearance
  useEffect(() => {
    if (tooltipActive) {
      showPopover();
    } else {
      dismissPopover();
    }
  }, [tooltipActive]);

  // Dismiss popover on window resize
  useEffect(() => {
    window.addEventListener("resize", dismissPopover);

    return () => {
      window.removeEventListener("resize", dismissPopover);
    };
  }, []);

  useClickOutsideElement(tooltipRef, dismissPopover);

  return (
    <span className={className}>
      Generated by{" "}
      <span
        className="tw-underline tw-cursor-pointer focus-visible:tw-outline-teal"
        onMouseEnter={() => setTooltipActive(!touchEventRef.current)}
        onMouseLeave={() => setTooltipActive(false)}
        onClick={() => setTooltipActive(!tooltipActive)}
        onKeyDown={handleKeyDown}
        onTouchStart={setTouchActive}
        ref={tooltipRef}
        role="button"
        tabIndex={0}
      >
        AI
      </span>{" "}
      using LitCharts content. Questions are reviewed by LitCharts and its
      service providers.
    </span>
  );
}
